<template>
  <div class="wrap order">
    <div class="header">
      <NavBar
        title="Checkout"
        left-arrow
        @click-left="$router.go(-1)"
        class="no_bg"
      >
        <!-- <span slot="right" icon="cart-o"><Icon name="cart-o"  badge="99+"/></span> -->
      </NavBar>
    </div>
    <div class="main">
      <!-- 地址 -->
      <div
        class="EditAddress"
        v-if="this.isLogin || this.address"
        @click="toAddress"
      >
        <div v-if="address" style="padding:10px 0">
          <div>
            {{ address.receiverName }} <span>{{ address.phone }}</span>
          </div>
          <div>
            {{ address.countriesEntity.name }}/{{ address.statesEntity.name }}/{{
              address.citiesEntity.name
            }}/{{ address.street }}/{{ address.address }}
          </div>
        </div>
        <div v-else>
          <Cell title="shipping">
            <template #title>
              <div class="FlexBox" style="color:#FF6060">
                <van-icon name="location-o" size="0.6rem" />
                <div class="pdl5" > Please slect address</div>
              </div>
            </template>
            <template #right-icon >
              <div style="color: #9BA1AA;">
                <van-icon  name="arrow" size="0.4rem"/>
              </div>
            </template>
          </Cell>
        </div>
      </div>
      <!-- 没登陆 -->
      <div v-else class="EditAddress" >
        <!-- <div @click="$router.push('/address/add')">Please add address</div> -->
        <Cell title="shipping"   @click="$router.push('/address/add')">
          <template #title>
            <div class="FlexBox" style="color:#FF6060">
              <van-icon name="location-o" size="0.6rem" />
              <div class="pdl5" >Please add address</div>
            </div>
          </template>
          <template #right-icon >
            <div style="color: #9BA1AA;">
              <van-icon  name="arrow" size="0.4rem"/>
            </div>
          </template>
        </Cell>
      </div>

      <!-- 商品list -->
      <div class="Separate"></div>
      <div class="catItme" v-for="(item, index) in list" :key="index">
        <div class="Product van-hairline--bottom">
          <div class="imgBox">
            <img
              :src="
                toPicProductImg(item.productEntity.productFileEntity.mainImg)
              "
              alt=""
            />
          </div>
          <div class="ProductText">
            <div>
              {{ item.productEntity.productName }}
              <div class="ProductDes">Free Shipping</div>
            </div>
            <div class="StepperBox">
              <div class="PriceX">{{ item.productEntity.nomalPrice  }}</div>
              <div>
                <Stepper
                  v-model="item.productAmount"
                  @plus="plus(item)"
                  @minus="plus(item)"
                  min="1"
                  integer
                  button-size="26px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 其他组 -->
      <CellGroup style="text-align:left">
        <Cell title="Subtotal">
          <span class="custom-title">{{
            Math.round(orderMoney * 1000) / 1000
          }}</span>
        </Cell>
        <!-- 优惠码 -->
        <Cell v-show="isdistrictMoney">
          <template #title>
            <span class="custom-title">Coupon</span>
            <span class="pdl5" style="color:#969799">{{ code }}</span>
            <!-- <Tag type="danger">标签</Tag> -->
          </template>
          <template #right-icon>
            <span class="custom-title pdr5" style="color:#E82A2A"
              >$ <span v-if="districtMoney != 0">-</span> {{ districtMoney }}</span
            >     
            <Tag v-if="code" plain type="danger" @click="removeCode()"
              >remove</Tag
            >
            <Tag v-else plain type="danger" @click="editCode()">add</Tag>
          </template>
        </Cell>
        <!-- 运费  -->
        <Cell title="shipping">
          <template #right-icon>
            <span class="custom-title">{{ fare }}</span>
          </template>
        </Cell>
        <!-- 扣除运费和折扣后的价格 -->
        <Cell title="Total">
          <template #right-icon>
            <span>{{ Total }}</span>
          </template>
        </Cell>
        <!-- <Cell title="Pay with">
          <template #title>
            <span class="custom-title pdr5">Pay with</span>
            <Tag plain type="danger">paypay支付</Tag>
          </template>
        </Cell> -->
      </CellGroup>
      <div class="Separate"></div>
      <div class="Remarks">
        <div class="tit">Order notes</div>
        <Field
          v-model="remark"
          rows="3"
          autosize
          type="textarea"
          maxlength="80"
          placeholder="Please enter a message"
          show-word-limit
        />
      </div>
      <div class="Separate"></div>
      <div class="protocol">
        <div class="FlexBox">
          <Checkbox v-model="ischecked" shape="square" bind:change="CheckboxFn" />
          <span class="pdl5 pdr5">I have read and agree to</span>
          <span @click="toProtocol"  style="color:#16C7CE">TERMS OF SERVICE</span>
        </div>
      </div>

      <div class="OrderFooter">
        <Button color="#16C7CE" type="primary" @click="paly" block>Palce order</Button>
      </div>
      <!--按钮组件-->
      <paypalbtn v-if="paypalShow" @msg="msg" :detail="detail" />
      <!-- 弹窗 -->
      <van-dialog
        v-model="show"
        title="Coupon Code"
        show-cancel-button
        width="90%"
        @confirm="confirm"
        :before-close="onBeforeClose"
        confirm-button-text="Confirm"
        cancel-button-text="Cancel"
      >
        <div>
          <div>
            <Field v-model="userCode" placeholder="Code" clearable />
          </div>
        </div>
      </van-dialog>
      <!-- closeable  x按钮 -->
      <Popup  position="bottom" :close-on-click-overlay="false"  @close="close"
        :style="{ height: '30%' }" v-model="show2">
        <div class="PayTitle">Select payment method</div>
        <div class="PayBox">
          <div class="PayBoxTop">
            <div>paypal</div>
            <img  id="paypal-button" src="../../../public/img/Paypal.png">
            <!-- <img  id="paypal-button" src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/logos-buttons/34_Grey_CheckOut_Pill_Button.png"> -->
          </div>
          <div class="PayBoxBot">
            <div>Add new card</div>
            <div></div>
          </div>
        </div>
      </Popup>
      <Overlay :show="ZZshow" :lock-scroll="false" class-name="modalimg" >
        <div class="LoadingBox">
          <Loading  type="spinner" color="#1989fa"></Loading>
        </div>
      </Overlay> 

    </div>
  </div>
</template>
<script>
import {httpUrl, baseUrl} from "../../api/config";
import request from "../../api/request";
import { toPicProductImg,objKeySort } from "../../utils/common";
import { Notify, Toast } from "vant";
import { getStore, setStore ,removeStore} from "../../utils/storage";
import paypalbtn from './paypalbtn.vue'
// import store from "./store";
export default {
  components: { paypalbtn },
  data() {
    return {
      allStr:'',//header所需要密文
      discount:JSON.parse(localStorage.getItem("codes"))?JSON.parse(localStorage.getItem("codes")).data.discount : 0,  //折扣百分比
      nonceFromTheClient :null ,  //付款授权流水码  子组件获取
      orderId:null,   //订单id

      userCode: "",  //弹窗绑定的code用于给code 赋值
      show: false,
      code:JSON.parse(localStorage.getItem("codes"))?JSON.parse(localStorage.getItem("codes")).data.couponCode : '' , //优惠券
      districtMoney: 0, //优惠金额
      Total: 0, //扣除运费和折扣后的价格
      fare: 0, //总运费
      orderMoney: 0, //总价格
      ischecked: true, //服务条款勾选
      remark: "", //留言备注
      list: [], // 商品list数据
      userId: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).id
        : '', //用户id
      address: null, //地址
      isLogin: getStore("user"),

      credentials: {
        // sandbox: 'Ad1voWYq3VL8J4jy6zWARKwz4tjbuDl_TFBa3WQqy_DwAFWd7hkU4i99jijGqaoqU3E-ODqXDayVnOdl',   //系统的
        sandbox:"AYmK2dN-JT7bpEaImW9Vg_tXI5EInLr1bog2ZLzrmiFoEmZgdLL3eMBbXS1VgKBMmI_Ua2U0g7yrUzxP", //
        production: ""
      },
      show2:false,   //底部弹窗
      show2Nuw:'1',  //底部弹窗判断依据

      detail:null,
      paypalShow:false,    //  支付按钮组件
      isdistrictMoney:false,   //是否展示优惠金额
      ZZshow:false   // 遮罩层
    };
  },

  created(){
    // console.log(JSON.parse(localStorage.getItem("codes")).discount)
  },
  watch:{
    nonceFromTheClient:{
      handler (newval, oldval) {  //有付款授权流水码就可以创建交易
        // console.log('新',newval,'旧',oldval)
        if(newval){
          let that = this
          that.show2 =false    //底部弹窗
          that.ZZshow = true   //遮罩层
          let dataSale = {
            deviceDataFromTheClient:'',
            orderId : that.orderId ,     //订单id
            paymentMoney : that.paymentMoney,   //交易金额
            nonceFromTheClient : newval ,  //付款授权流水码
          }
          let str = dataSale  
          str = objKeySort(str)   //排序.
          let allStr ='' //排序.按照后端规则添加header密文
          for(let key in str){
            allStr += key + '=' + str[key]
            // if(str[key] != ''&& str[key] != null){
            //   allStr += key + '=' + str[key]
            // }
          }
          allStr = allStr + 'token=6bcf8aa476d6f36b3c513a90a9451240'
          console.log(allStr)
          request("put", "cms/order/createSale", dataSale,allStr).then(res => {
            if(res.code === 200) {   //扣钱得接口
              removeStore('codes')
              this.$router.push({
                path:'/orderSuccess',
                query:{
                  orderSn:res.data.orderSn,
                  paymentMoney:res.data.paymentMoney,
                  payTime:res.data.payTime,
                }
              })  
            }
          }).catch((err)=>{
            console.log(err)
            this.$router.push({
              path : '/orderFail',
            })
          });
        }
      },
      deep: true,
      immediate: true  
    }

    
  },
  mounted() {
    removeStore;
    this.getSandbox(); //获取订单令牌
    this.pull();
    if (this.isLogin) {
      // 登陆去获取默认地址
      let Address = JSON.parse(getStore("Address"));
      if(Address){
        this.address = Address;
      }else{
        this.getAddress();
      }
      // if (Address) {
      //   //缓存地址是从地址列表进来直接赋值，
      //   this.address = Address;
      // } else {
      //   //否则是直接掉
      //   this.getAddress();
      // }
    } else {
      let Address = JSON.parse(getStore("Address"));
      // console.log(Address)
      if (Address) {
        //缓存地址是从地址列表进来直接赋值，
        this.address = Address;
      }
    }
  },
  methods: {
    toPicProductImg,
    CheckboxFn() {},
    toProtocol(){ // 跳转协议页
      // let src = 'http://192.168.1.71:7115/protocol/serviceTerms.html'
      let src = httpUrl+'protocol/serviceTerms.html'
      window.open(src,"_blank")
    },
    msg(data){
      // console.log(data)
      this.nonceFromTheClient = data.nonceFromTheClient   //
      this.paypalShow = data.paypalShow
    },
    editCode() {
      // 更改优惠券
      this.show = true;
    },
    toAddress() {
      //  重新选择地址
      if (this.isLogin) {
        let urls = window.location.href ; //获取url中"?"符后的字串       
        let orderHttp = urls.split('?')[1]; 
        setStore('orderHttp',orderHttp)
        this.$router.push("/address");
      } else {
        this.$router.push("/address/add");
        // return;
      }
    },
    confirm() {
      // 弹窗确定
      let data = {
        code: this.userCode , //有效的code RF6FWzk
        // code: 'RF6FWzk' //有效的code RF6FWzk
      };
      request("get", "cms/couponuser/checkCode", data).then(res => {
        if (res.code === 200) {
          // setStore('codes',res); //  判断是否领取过优惠券的状态
          this.code = this.userCode
          this.discount = res.data.couponUserEntity.couponEntity.discount   //折扣百分比
          this.pull()
        } else {
          // let text = res.code =='150002' ? 'expired' : res.msg
          // Notify({ type: "danger", message: text });
        }
      });
      // this.userCode = "";
      this.show = false;
    },
    onBeforeClose(action, done) {
      if (action == "confirm") {
        return done(false); //阻止关闭弹窗
      } else if (action == "cancel") {
        // this.userEmail = ''
        return done();
      }
    },
    removeCode() {
      // 删除优惠券
      let that = this
      this.$dialog
        .confirm({
          confirmButtonText:"Confirm",
          cancelButtonText:"Cancel",
          title: "delete",
          message: "Are you sure to delete the coupon?"
        })
        .then(() => {
          // this.code = "";
          // this.districtMoney = 0
          removeStore("codes");
          location.reload()
        })
        .catch(e => {});
    },
    
    pull() {
      //获取商品列表
      // console.log(this.$route.query)
      if (this.$route.query.cartIds) {
        // 如果有购物车id 那么就是从购物车进来的否则就是从立即购买进来的
        let data = {
          cartIds: this.$route.query.cartIds,
          productIds: this.$route.query.productIds
        };
        request("get", "cms/ordercart/queryCartByCartIds", data).then(res => {
          if (res.code === 200) {
            this.list = res.data;
            this.plus();
            this.fare = 0;
            this.list.forEach(item => {
              this.fare += item.productEntity.fare; //算运费
              if(item.productEntity.parUnion == 0){
                this.isdistrictMoney = true
              }
            });
          }
        });
      } else {
        let data = {
          productId: this.$route.query.productId
        };
        request("get", "cms/product/selectByProductId", data).then(res => {
          if (res.code === 200) {
            this.list = [];
            let a = {
              productEntity: res.data,
              price: res.data.nomalPrice,
              productAmount: 1,
              productId:res.data.productId,
              fare:res.data.fare
            };
            this.list.push(a);
            this.plus();
            this.fare = 0;
            this.list.forEach(item => {
              this.fare += item.productEntity.fare; //算运费
              if(item.productEntity.parUnion == 0){
                this.isdistrictMoney = true
              }
            });
          }
        });
      }
    },
    getAddress() {
      //获取用户获取默认地址
      request("get", "cms/customeraddr/getIsDefaultAddrOrNewAddr").then(res => {
        if (res.code === 200) {
          this.address = res.data;
          console.log(this.address);
        }
      });
    },
    plus() {
      // 数量增加
      this.$nextTick(() => {
        // this.totalMoney = 0;
        let allMoney = 0 
        let zhekouMoney = 0
        // console.log(this.list)
        this.list.forEach(item => {    
          allMoney +=  this.accMul(item.productEntity.nomalPrice, item.productAmount)
          if(item.productEntity.parUnion==0){  //如果是非联盟商品0参与，1不参与就不会计算
            zhekouMoney += this.accMul(item.productEntity.nomalPrice, item.productAmount)* this.discount
          }
          // this.orderMoney += this.accMul(item.productEntity.nomalPrice, item.productAmount);
        });
        this.orderMoney = allMoney
        // this.districtMoney =  Math.round(this.orderMoney * this.discount *100)/100 
        this.districtMoney =  Math.round(zhekouMoney *100)/100
        this.Total = Math.round((this.orderMoney  + this.fare - this.districtMoney)*100)/100
      });
    },
    // 数量单价乘积
    accMul(price, num) {
      let a = Math.round(price * num * 1000) / 1000;
      return a;
    },
    getSandbox(num) {
      // 结算后从后台获取沙箱Box玛
      request("get", "cms/order/getClientToken").then(res => {
        if (res.code === 200) {
          this.credentials.production = res.data;
          // console.log(this.credentials);
        }
      });
    },

    paly() {
      if (this.address) {
        //判断是不是有地址
        let data = {
          code: this.userCode , //有效的code RF6FWzk
          // code: 'RF6FWzk' //有效的code RF6FWzk
        };
        let list = [];
        console.log(121,this.list)
        this.list.forEach(item => {
          let obj = {
            productId: item.productId,
            productCnt: item.productAmount,
            parUnion:item.productEntity.parUnion,
            productName: item.productEntity.productName,
            productPrice: item.productEntity.nomalPrice,
            // feeMoney: item.productEntity.discountPrice,
          };
          list.push(obj);
        });

        let pramas = {
          productId: this.$route.query.productId, //购物车ids，多个用逗号分隔
          cartIds: this.$route.query.cartIds?this.$route.query.cartIds:'', //购物车ids，多个用逗号分隔
          submitType: this.$route.query.cartIds?"1":"0", //0：立即购买提交的订单；1：购物车提交的订单
          address: this.address.address, //具体的门牌号
          city: this.address.city, //城市
          country: this.address.country, //国家
          states: this.address.states, //所属州
          street: this.address.street, //街道
          zipCode: this.address.zipCode, //收货人邮编
          phone: this.address.phone, //收货人电话
          receiverEmail: this.address.receiverEmail, // 收货人邮箱
          receiverName: this.address.receiverName, //收货人姓名
          jsonStr: JSON.stringify(list), //订单详情的JSon
          // jsonStr: list, //订单详情的JSon
          remark: this.remark, //备注
          code: this.code, //优惠劵
          // couponId:'12',//优惠券ID
          districtMoney: this.districtMoney, //优惠金额
          orderMoney: this.orderMoney, //订单总金额
          paymentMethod: 1, //支付方式 1PAYPAL，2余额，3网银，4支付宝，5微信
          paymentMoney: this.Total, // 实际支付金额
          // shippingMoney: this.fare, // 运费金额
          sourceType: 2 , //订单来源：0->PC订单；1->app订单；2->H5订单
          orderCustomerId:this.userId  //下单人id
        };
        if(this.code != ''){
          pramas.recomCustomerId = getStore("recomCustomerId")   //推荐人id  ,
          pramas.couponUserId = JSON.parse(localStorage.getItem("codes")).data.couponUserId
        }
        let str = pramas  
        str = objKeySort(str)   //排序.
        let allStr ='' //排序.按照后端规则添加header密文
        for(let key in str){
          allStr += key + '=' + str[key]
          // if(str[key] != ''&& str[key] != null){
          //   allStr += key + '=' + str[key]
          // }
        }
        allStr = allStr + 'token=6bcf8aa476d6f36b3c513a90a9451240'
        console.log(allStr)
        request("posthead", "cms/order/save", pramas, allStr).then(res => {
          if (res.code === 200) {
            this.orderId = res.data.orderInfo.orderId    //创建交易用
            this.paymentMoney = res.data.orderInfo.paymentMoney //创建交易用
            this.detail = {
              amount:res.data.orderInfo.paymentMoney,   
              client_token:this.credentials.production
            }
            this.paypalShow = true
            this.show2 =true
          }
        });
      } else {
        this.$toast.fail("Please add address first");
      }
    },
    // 关闭支付面板
    close(){
      // this.$router.push({
      //   path : '/orderFail',
      // })
    }

  }
};
</script>
<style lang="less" scoped>
.order {
  .pdl5 {
    padding-left: 15px;
  }
  .pdr5 {
    padding-right: 15px;
  }
  background: #fff;
  font-size: 12px;
  .EditAddress {
    padding: 20px 10px;
    text-align: left;
    .left {
      padding-bottom: 5px;
      font-weight: bold;
    }
  }
  .catItme {
    background: #fff;
    padding: 10px;
    .Product {
      display: flex;
      padding-bottom: 10px;
      .imgBox {
        img {
          width: 86px;
          height: 86px;
        }
      }
      .ProductText {
        padding-left: 10px;
        flex: 1;
        display: flex;
        flex-flow: column;
        justify-content: space-around;
        text-align: left;
        font-size: 15px;
        .ProductDes {
          font-size: 13px;
          color: #9ba1aa;
          padding-top: 5px;
        }
        .StepperBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }
  .Remarks {
    .tit {
      text-align: left;
      font-weight: bold;
      padding: 10px 0 0 10px;
    }
  }
  .OrderFooter {
    padding: 5px 10px 10px 10px;
  }
  .protocol {
    padding: 0 10px;
    display: flex;
    justify-items: center;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 12px;
  }
  .PayTitle{
    text-align: center;
    height: 50px;
    line-height: 50px;
  }
  .PayBox{
    width: 100%;
    padding: 10px 10px 10px 10px;
  }
  .PayBoxTop{
    img{
      width:20%;
      padding: 10px 0 10px 10px;
    } 
  }
  .LoadingBox{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
<style>
.order .van-cell {
  font-size: 12px;
}
.order .van-checkbox__icon .van-icon {
  font-size: 12px;
}
</style>
